module.exports = __webpack_public_path__ + "static/5-90cf194dcd94cc26a96f021470e4e33a.webp";